import { getAuthAxiosBackend } from "../helpers/axios"

class AdminServices{

    get(id){
        return getAuthAxiosBackend().get('users/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('users', {params: data})
    }

    add(admin){
        return getAuthAxiosBackend().post('users', admin)
    }

    edit(id, admin){
        return getAuthAxiosBackend().put('users/'+id, admin)
    }

    delete(id){
        return getAuthAxiosBackend().delete('users/'+id)
    }

    resetPassword(id, data){
        return getAuthAxiosBackend().put('user/password/reset/'+id, data)
    }
}

export default new AdminServices()